import { FileContextEnum, FileRecordTypeEnum, PathNode } from '../../types/file-record';

export function bytesToMB(bytes: number): number {
    return bytes / 1024 / 1024;
}

export function getRedirectPath(
    filePath: PathNode[],
    folderId: string,
    folderContext?: FileContextEnum | null | undefined
): string | undefined {
    let redirectPath: string | undefined;

    if (folderContext === FileContextEnum.WORKSHEET) {
        const workpaperFolderId = filePath.find((p) => p.context === FileContextEnum.WORKPAPER)?.id;

        if (workpaperFolderId) {
            redirectPath = `/workpapers/${workpaperFolderId}/trial-balance/${folderId}?folder=${folderId}&tab=files`;
        }
    }

    if (folderContext === FileContextEnum.OTHER_SCHEDULE) {
        const workpaperFolderId = filePath.find((p) => p.context === FileContextEnum.WORKPAPER)?.id;

        if (workpaperFolderId) {
            redirectPath = `/workpapers/${workpaperFolderId}/other-schedules/${folderId}?folder=${folderId}&tab=files`;
        }
    }

    if (folderContext === FileContextEnum.GROUP) {
        redirectPath = `/groups/${folderId}?folder=${folderId}&tab=files`;
    }

    if (folderContext === FileContextEnum.ENTITY) {
        redirectPath = `/entities/${folderId}?folder=${folderId}&tab=files`;
    }

    if (folderContext === FileContextEnum.WORKPAPER) {
        redirectPath = `/workpapers/${folderId}/files?folder=${folderId}`;
    }

    if (folderContext === FileContextEnum.FIRM) {
        redirectPath = '';
    }

    return redirectPath;
}

/**
 * Check if a user has write access to files
 *
 * @param isExternalUser If user is has an EXTERNAL_USER role
 * @param assignedWorkpapers Assigned workpapers to users with EXTERNAL_USER
 * @param filePaths Paths for file records
 * @returns True if user has write access to files otherwise false
 */
export function hasWriteAccess(isExternalUser: boolean, assignedWorkpapers: string[] | null, filePaths: PathNode[][]): boolean {
    return !(isExternalUser && assignedWorkpapers !== null && !filePaths.find((fp) => fp.find((p) => assignedWorkpapers.includes(p.id))));
}

/**
 * Check if a record is a folder/folder reference
 *
 * @param recordType FileRecordTypeEnum
 * @returns True if record is a folder/folder reference, otherwise false
 */
export function isFolderType(recordType: FileRecordTypeEnum): boolean {
    return recordType === FileRecordTypeEnum.FOLDER || recordType === FileRecordTypeEnum.FOLDER_REFERENCE;
}
